/* @flow */
import { createElement, Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import LoadingIndicator from 'components/LoadingIndicator.jsx';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * Renders a loading indicator until every property named in `keys` is not undefined.
 */
function awaitData<Props: {}>(
  keys: string[],
  loadingIndicator: React$Element<any> = createElement(LoadingIndicator)
) {
  return function wrapWithDataRequirement(WrappedComponent: *) {
    class AwaitData extends Component<Props> {
      static displayName = `awaitData(${getDisplayName(WrappedComponent)})`;

      render() {
        const loaded = keys.every(key => this.props[key] !== undefined);
        if (loaded) {
          return createElement(WrappedComponent, this.props);
        }
        return loadingIndicator;
      }
    }
    return hoistNonReactStatics(AwaitData, WrappedComponent, {});
  };
}

export default awaitData;
